<template>
  <v-dialog v-model="dialog" max-width="700px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', pisCofins)">
      <v-card v-if="pisCofins" :loading="salvando">
        <v-card-title>{{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} PISCOFINS</v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="pisCofins.descricao"
                    label="Descrição"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="pisCofins.observacao"
                    label="Observação"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="pisCofins.percentualPISEntrada"
                    type="number"
                    label="PIS Entrada"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="pisCofins.percentualPISSaida"
                    type="number"
                    label="PIS Saída"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="pisCofins.percentualCOFINSEntrada"
                    type="number"
                    label="COFINS Entrada"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="pisCofins.percentualCOFINSSaida"
                    type="number"
                    label="COFINS Saída"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="pisCofins.cstEntrada.id"
                    :items="itens.cst"
                    :rules="[obrigatorio]"
                    label="CST Entrada"
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="pisCofins.cstSaida.id"
                    :items="itens.cst"
                    :rules="[obrigatorio]"
                    label="CST Saída"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="pisCofins.ncm.id"
                    :items="itens.ncm"
                    :rules="[obrigatorio]"
                    label="NCM"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="pisCofins.lei.id"
                    :items="itens.lei"
                    :rules="[obrigatorio]"
                    label="Lei"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="pisCofins.naturezaEntrada.id"
                    :items="itens.naturezaEntrada"
                    label="Natureza Entrada"
                    clearable
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="pisCofins.naturezaSaida.id"
                    :items="itens.naturezaSaida"
                    label="Natureza Saída"
                    clearable
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(pisCofins)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import PISCOFINS from '@/models/piscofins'
import PISCOFINSService from '@/services/pisCofins/pisCofins'
import { obrigatorio } from '@/shareds/regrasForm'

export default {
  props: ['showDialog', 'pisCofinsParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    pisCofins: new PISCOFINS(),
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false,
    menuDataInicio: false,
    menuDataFim: false
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    pisCofinsParam() {
      return this.pisCofinsParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.pisCofins = new PISCOFINS()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.pisCofins = this.pisCofinsParam
      if (!this.pisCofins.naturezaEntrada) {
        this.pisCofins.naturezaEntrada = { id: null, codigo: null }
      }
      if (!this.pisCofins.naturezaSaida) {
        this.pisCofins.naturezaSaida = { id: null, codigo: null }
      }
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item
        }

        const piscofinsSalva =
          this.operacao === 'adicionar'
            ? await PISCOFINSService.create({ ...data })
            : await PISCOFINSService.update(data.id, data)

        this.$emit('confirmado', piscofinsSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
